export default __webpack_public_path__ + "locales/fi/SocialAuthWelcomeDialog.json?hash=120826c0978ce286b43778c861a7050f";